import React from "react";
import {useApiQuery} from "../../services/useApiQuery.ts";
import {Access} from "../../services/types.ts";
import AccessKeyPrompt from "../accessKey/AccessKeyPrompt.tsx";
import AdminAccessBlockedMessage from "../accessKey/AdminAccessBlockedMessage.tsx";
import {Card, Spinner} from "@fluentui/react-components";
import {useTranslation} from "react-i18next";
import {resolveAccessState} from "../../utils/adminAccess.util.ts";

interface SecuredWrapperProps {
    children: React.ReactNode;
    selfServiceButton: React.ReactNode;
}

export const SecuredWrapper: React.FC<SecuredWrapperProps> = (props: SecuredWrapperProps) => {
    const { t } = useTranslation();

    const {
        data: access,
        refetch: recheckAccess,
        isPending: accessLoading,
    } = useApiQuery<Access>('/api/access/check');

    const accessState = resolveAccessState(access);

    if (accessLoading) {
        return <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
                {props.selfServiceButton}
            </div>
            <Card><Spinner label={t("text.checking-credentials")}/></Card>
        </div>;
    }

    if (accessState === "admin") {
        return <div>{props.children}</div>;
    }

    if (accessState === "bootstrap_choice") {
        return <div>
            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
                {props.selfServiceButton}
            </div>
            <AccessKeyPrompt recheckAccess={recheckAccess} canStartEvaluation={access?.canStartEvaluation}/>
        </div>;
    }

    return <div>
        <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "12px"}}>
            {props.selfServiceButton}
        </div>
        <AdminAccessBlockedMessage accessState={accessState} organizationName={access?.organizationName}/>
    </div>;
};
